<script>

import TrainerForm from "@/components/users/TrainerForm.vue";

export default {
    components: {TrainerForm},
    data() {
        return {
            errors: {},
            loading: true,
            user: {},
            controller: new AbortController()
        }
    },
    mounted() {
        axios.get(`/users/${this.$route.params.id}`, {
            signal: this.controller.signal
        }).then((response) => {
            this.user = response.data.data;
        }).finally(() => {
            this.loading = false;
        })
    },
    beforeUnmount() {
        this.controller.abort();
    }
}

</script>
<template>
    <div class="employee-edit">

        <loader :loading="loading"/>

        <trainer-form v-if="!loading" :user="user"/>

    </div>
</template>
